import React, { useEffect, useMemo } from 'react'
import { useDispatch } from 'react-redux'
import i18n from 'simple-react-i18n'
import { Outlet } from 'react-router-dom'
import { Box } from '@mui/material'
import BoundaryError from 'log/components/BoundaryError'
import HomeAction from 'home/actions/HomeAction'
import FixedSlideNav from '../../../components/navbar/FixedSlideNav'
import useActions from 'utils/customHook/useActions'

const FtpTreeApp = () => {
    const dispatch = useDispatch()

    useActions(() => ({}), [])

    useEffect(() => {
        dispatch(HomeAction.setTitle([
            {
                title: i18n.ftpTree,
                href: '/job/ftp',
            },
        ]))
    }, [dispatch])

    const navLinks = useMemo(() => [
        {
            href: '/job/list',
            name: i18n.jobs,
            icons: 'cached',
            'data-cy': 'nav-import',
        },
        {
            href: '/job/ftp',
            name: i18n.ftpTree,
            icons: 'folder_zip',
            'data-cy': 'nav-ftp',
        },
    ], [])

    return (
        <Box>
            <FixedSlideNav links={navLinks} />
            <Box className='content-page fullscreen' padding={1}>
                <BoundaryError>
                    <Outlet />
                </BoundaryError>
            </Box>
        </Box>
    )
}

export default FtpTreeApp